<template>
  <div v-if="!item.hidden" class="wly-item-wrapper">
    <!-- <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template> -->
    <template v-if="!item.children || !item.children.length">
      <app-link v-if="item.meta.islink" :to="item.path">
        <el-menu-item :index="resolvePath(item.path)" class="submenu-title-noDropdown">
          <item :icon="item.meta.icon" :title="item.meta.title" />
        </el-menu-item>
      </app-link>
      <router-link v-if="item.meta && !item.meta.islink" :to="resolvePath(item.path)" @click.native="routeClick(item)">
        <el-menu-item :index="resolvePath(item.path)" class="submenu-title-noDropdown">
          <item :icon="item.meta.icon" :title="item.meta.title" />
        </el-menu-item>
      </router-link>
    </template>

    <el-submenu v-else ref="subMenu" class="wly-submenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item v-for="child in item.children" :key="computedKey(child)" :is-nest="true" :item="child" :base-path="resolvePath(child.path)" class="nest-menu" />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import FixiOSBug from './FixiOSBug'
import eventBus from '@/utils/eventBus'
import AppLink from './Link.vue'
export default {
  name: 'sidebar-item',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  computed: {

  },
  methods: {
    routeClick(item) {
      eventBus.$emit('pageReload')
    },
    hasOneShowingChild(children = [], parent) {
      if (!children) {
        return false
      }
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    computedKey(child) {
      return child.path + `${child.meta ? child.meta.id : ''}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/SidebarItem.vue